import { useCallback } from 'react'
import { useSettings } from './useSettings'
import { applyThemeSelection, type Theme } from '../lib/accountTheme'

function normalizeTheme(value: unknown): Theme {
  return value === 'light' || value === 'system' ? value : 'dark'
}

/** One mutation path for every Account theme surface. */
export function useAccountTheme() {
  const { settings, updateSetting } = useSettings()
  const theme = normalizeTheme(settings?.theme)

  const chooseTheme = useCallback(async (nextTheme: Theme) => {
    const previousTheme = normalizeTheme(settings?.theme)
    applyThemeSelection(nextTheme)
    try {
      await updateSetting('theme', nextTheme)
    } catch (error) {
      applyThemeSelection(previousTheme)
      console.error('Failed to save theme preference:', error)
      throw error
    }
  }, [settings?.theme, updateSetting])

  return { theme, chooseTheme }
}
